import React from 'react'
import { toast } from 'react-toastify'

import styles from './MyReferralCodes.module.scss'

import { AUTO_CLOSE_DELAY } from '../FlashMessage'

import { copyTextToClipboard } from './helpers'

const MyReferralCodesShareSection = ({ referralUrl, shareLinks }) => {
  const onClick =
    ({ redirectUrl, redirectName }) =>
    (e) => {
      e.preventDefault()

      copyTextToClipboard({
        text: referralUrl,
        success: () => {
          toast.success(
            <div>
              Referral link copied to clipboard.
              <br />
              Redirecting to {redirectName}.
            </div>,
            { autoClose: AUTO_CLOSE_DELAY }
          )

          setTimeout(() => {
            window.location.href = redirectUrl
          }, AUTO_CLOSE_DELAY)
        },
      })
    }

  return (
    <div className={styles.section}>
      <h2>Post or share your personal referral link:</h2>
      <br />

      <ul className={styles.social}>
        <li>
          <a href={shareLinks.email} target="_blank" className={styles.email}>
            {/* Mail SVG from: https://css.gg/mail */}
            <svg xmlns="https://www.w3.org/2000/svg" fill="none" viewBox="1 0 21 21">
              <path
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href={shareLinks.twitter} target="_blank" className={styles.twitter}>
            {/* All other SVG from: https://tailwind-elements.com/docs/standard/components/social-buttons/ */}
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="0 -25 512 512">
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
            </svg>
          </a>
        </li>
        <li>
          <a href={shareLinks.facebook} target="_blank" className={styles.fb}>
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
              <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href={shareLinks.instagram}
            className={styles.instagram}
            onClick={onClick({ redirectUrl: shareLinks.instagram, redirectName: 'Instagram' })}
          >
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="-1 -2 26 26">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href={shareLinks.tiktok}
            className={styles.tiktok}
            onClick={onClick({ redirectUrl: shareLinks.tiktok, redirectName: 'TikTok' })}
          >
            <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                fill="currentColor"
                d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href={shareLinks.pinterest} className={styles.pinterest} target="_blank">
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="0 -5 496 512">
              <path d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3 .8-3.4 5-20.3 6.9-28.1 .6-2.5 .3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href={shareLinks.snapchat}
            className={styles.snapchat}
            onClick={onClick({ redirectUrl: shareLinks.snapchat, redirectName: 'Snapchat' })}
          >
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="-2 -2 27 27">
              <path d="M5.829 4.533c-.6 1.344-.363 3.752-.267 5.436-.648.359-1.48-.271-1.951-.271-.49 0-1.075.322-1.167.802-.066.346.089.85 1.201 1.289.43.17 1.453.37 1.69.928.333.784-1.71 4.403-4.918 4.931-.251.041-.43.265-.416.519.056.975 2.242 1.357 3.211 1.507.099.134.179.7.306 1.131.057.193.204.424.582.424.493 0 1.312-.38 2.738-.144 1.398.233 2.712 2.215 5.235 2.215 2.345 0 3.744-1.991 5.09-2.215.779-.129 1.448-.088 2.196.058.515.101.977.157 1.124-.349.129-.437.208-.992.305-1.123.96-.149 3.156-.53 3.211-1.505.014-.254-.165-.477-.416-.519-3.154-.52-5.259-4.128-4.918-4.931.236-.557 1.252-.755 1.69-.928.814-.321 1.222-.716 1.213-1.173-.011-.585-.715-.934-1.233-.934-.527 0-1.284.624-1.897.286.096-1.698.332-4.095-.267-5.438-1.135-2.543-3.66-3.829-6.184-3.829-2.508 0-5.014 1.268-6.158 3.833z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href={shareLinks.youtube}
            className={styles.youtube}
            onClick={onClick({ redirectUrl: shareLinks.youtube, redirectName: 'YouTube' })}
          >
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="0 -1 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href={shareLinks.linkedin}
            className={styles.linkedin}
            onClick={onClick({ redirectUrl: shareLinks.linkedin, redirectName: 'LinkedIn' })}
          >
            <svg xmlns="https://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
              <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
            </svg>
          </a>
        </li>
      </ul>
    </div>
  )
}

export default MyReferralCodesShareSection
